<template>
  <div class="m-bottom" :style="elStyle">
    <a class="m-bottom__bp" :style="aStyle" @click="onDownload"></a>
  </div>
</template>
<script>
export default {
  name: 'McFixedBottom',
  props: {
    imageValue: {
      type: Object,
      default: () => {}
    },
    moduleId: {
      type: Number
    },
    viewStatus: {
      type: Number
    }
  },
  data() {
    return {
      height: 120,
      defaultImage:
        'https://yxfile.3k.com/2023/06/09/upload_pyz6ynj688xo65naqupa13zvavpkxt23.png'
    };
  },
  computed: {
    elStyle() {
      return {
        paddingBottom: this.$unit(this.height)
      };
    },
    aStyle() {
      return {
        height: this.$unit(this.height),
        backgroundImage: `url(${
          this.imageValue.imagePath || this.defaultImage
        })`
      };
    }
  },
  watch: {
    imageValue() {
      this.init();
    }
  },
  methods: {
    init() {
      let img = new Image();
      img.onload = () => {
        let h = img.height;
        this.height = h;
      };
      img.src = this.imageValue.imagePath;
    },
    async onDownload() {
      if (this.viewStatus == 1) return;
      if (this.imageValue.jumpPath != '') {
        this.Track(2, this.moduleId);
        setTimeout(() => {
          window.location.href = this.imageValue.jumpPath;
        }, 1000);
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.m-bottom {
  &__bp {
    position: fixed;
    display: block;
    bottom: 0;
    left: 0;
    width: 100%;
    background: no-repeat center/100% 100%;
    z-index: 500;
  }
}
</style>
